import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import { selectShouldShowStartTourneyButton } from '../../redux/reducers/pokerReducer';
import { useAppSelector } from '../../redux/store';
export const TableStatusOverlayDisplay = () => {
    const statusMessage = useAppSelector((state) => state.poker.statusMessage);
    const tableAreaDimensions = useAppSelector((state) => state.gameDimensions.tableAreaDimensions, shallowEqual);
    const communityCardsAreaWidth = useAppSelector((state) => state.gameDimensions.communityCardsBounds?.w);
    // Sometimes the table status can be displayed over existing community/rabbit cards. In this case, adjust the styling to be more visible:
    const shouldShowHighContrast = useAppSelector((state) => !!state.poker.communityCards.length || !!state.poker.rabbits.length);
    // Because the 'start tourney' button occupies the same space as the 'table status' display, and status
    // messages are likely not relevant in this context, don't show anything in this case.
    const shouldShowStartTourneyButton = useAppSelector(selectShouldShowStartTourneyButton);
    const containerCss = useMemo(() => {
        if (!tableAreaDimensions) {
            return;
        }
        return css `
      z-index: 1;
      position: absolute;
      left: ${tableAreaDimensions.w / 2}px;
      top: ${tableAreaDimensions.h / 2}px;
      max-width: ${communityCardsAreaWidth}px;
      transform: translate(-50%, -50%);
      pointer-events: none;
      // TODO: Instead of white, create a color that is a little brighter than the table felt:
      background-color: rgba(255, 255, 255, ${shouldShowHighContrast ? 0.85 : 0.2});
      border-radius: 10px;
      padding: 10px;
      text-align: center;
    `;
    }, [communityCardsAreaWidth, shouldShowHighContrast, tableAreaDimensions]);
    if (!statusMessage || shouldShowStartTourneyButton || !containerCss) {
        return null;
    }
    return (_jsx("section", { css: containerCss, "aria-label": 'table status', children: statusMessage }));
};
